$('body').addClass('is-active');

new ScrollHint('.js-scrollable', {
  suggestiveShadow: true
});

$(window).scroll(function() {
  $('#shopify-section-general-header, .js-header-sideScroll').css({'left': `-${$(this).scrollLeft()}px`});
});

let options = {
  threshold: [0, 0, 0, 0]
}
const observerEnter = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if(entry.intersectionRatio >= 0.9) {
      $('.js-header').removeClass('is-active');
    } else {
      $('.js-header').addClass('is-active');
    }
  });
}, options);

let el = document.querySelector('.js-header-trigger')
observerEnter.observe(el);

// -------------------------------------------------
// ヘッダー
// -------------------------------------------------

$('.js-drawer-trigger').click(function() {
  $('html').toggleClass('is-drawer');
  scrollBan();
})

// -------------------------------------------------
// ヘッダー
// -------------------------------------------------

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------

let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}

// -------------------------------------------------
// レシピ モーダル
// -------------------------------------------------

$('.js-modal-open').click(function() {
  scrollBan();
  modal_add($(this));

  $('.js-modal').addClass('is-active');
})

$('.js-modal-close').click(function() {
  scrollBan();
  $('.js-modal').removeClass('is-active')

  $('.js-modal-scroll')[0].scrollTop = 0;
})

function modal_add(el) {
  let img = el.next().find('.js-img').attr('src');
  let modal_inner = el.next().find('.js-inner').clone()[0];

  $('.js-modal .js-img').attr('src', img);
  $('.js-modal .js-inner').replaceWith(modal_inner);
}

// -------------------------------------------------
// MV swiper
// -------------------------------------------------


var $slide = $(".mv-slider")
  .slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    speed: 4000,
    autoplaySpeed: 4000,
    autoplay: true
  })
  .on({
    beforeChange: function(event, slick, currentSlide, nextSlide) {
      $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
      $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");
    },
    afterChange: function() {
      $(".preve-slide", this).removeClass("preve-slide　slide-animation");
    }
  });
$slide.find(".slick-slide").eq(0).addClass("slide-animation");


// -------------------------------------------------
// 一番上に戻るボタン(フッター)
// -------------------------------------------------

const topBackBtn = document.querySelector(".js-top-back")

topBackBtn.addEventListener("click", () => {
   window.scroll({
    top: 0,
    behavior: "smooth",
  });
  document.querySelector(".js-header").classList.remove("is-active")
})
